import React from 'react'
import { Box, Typography, Container, Divider } from '@mui/material'
import { motion } from 'framer-motion'
import { ABOUT } from '../content/Content'
import {
   AnimatedText,
   createMotionVariants,
} from '../components/animated/AnimatedComponent'
import { Colors } from '../constants/Colors'

const AboutPage: React.FC = () => {
   return (
      <Container maxWidth="md">
         <Box sx={{ mb: 6 }}>
            <AnimatedText text={ABOUT.experience.title} type="title" />
            {ABOUT.experience.description.map((desc, index) => (
               <AnimatedText
                  key={index}
                  text={desc}
                  type="description"
                  delay={index * 0.3}
               />
            ))}
         </Box>

         <Divider sx={{ my: 4 }} />

         <Box sx={{ mb: 6 }}>
            <AnimatedText text={ABOUT.skills.title} type="title" />
            {ABOUT.skills.description.map((desc, index) => (
               <AnimatedText
                  key={index}
                  text={desc}
                  type="description"
                  delay={index * 0.3}
               />
            ))}
         </Box>

         <Divider sx={{ my: 4 }} />

         <Box sx={{ mb: 6 }}>
            <AnimatedText text={ABOUT.timeline.title} type="title" />
            {ABOUT.timeline.description.map(({ year, job }, index) => (
               <motion.div
                  key={index}
                  initial="hidden"
                  animate="visible"
                  variants={createMotionVariants('description')}
               >
                  <Typography sx={{ color: Colors.DARK_GRAY, mb: 1 }}>
                     <strong>{`${year}:`}</strong> {job}
                  </Typography>
               </motion.div>
            ))}
         </Box>
      </Container>
   )
}

export default AboutPage
